import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6aa157c12253d30014e1a0bf_1788978997663_b3ae6e39/biolink/src/app/sign-up-login-screen/components/AuthScreen.tsx");
